import { ClientSettingFeatures } from "../../model/reference/settingsTypes";
import { Asset } from "../../model/viewModel/asset";
import { IHasGroupedConnectionPoints } from "../../model/viewModel/IHasGroupedConnectionPoints";
import { FindAllItem } from "../../app/networkSlice";

const hasGroupedConnectionPoints = (asset: Asset): asset is Asset & IHasGroupedConnectionPoints => {
  const gcp = (asset as Partial<IHasGroupedConnectionPoints>).groupedConnectionPoints;
  return Array.isArray(gcp);
};

export const createDefaultsChecker = (features: ClientSettingFeatures) => {
  // Build once per instance
  const excluded = new Set<string>();
  if (!features.TransformerPrimaryVoltageEnabled) {
    excluded.add("primaryVoltagekVIsDefault");
  }

  const hasDefaultFlag = (asset: Asset): boolean =>
    Object.entries(asset).some(
      ([k, v]) => k.endsWith("IsDefault") && !excluded.has(k) && Boolean(v),
    );

  const checkAssetForDefaults = (asset: Asset): boolean =>
    hasDefaultFlag(asset) ||
    (hasGroupedConnectionPoints(asset) &&
      asset.groupedConnectionPoints.some((gcp) => hasDefaultFlag(gcp)));

  const checkAssetsForDefaults = (allAssets: Asset[]): boolean =>
    allAssets.some(checkAssetForDefaults);

  const checkFindAllItemsForDefaults = (findAllItems: FindAllItem[]): boolean =>
    checkAssetsForDefaults(findAllItems.map(({ asset }) => asset));

  return { checkFindAllItemsForDefaults, checkAssetsForDefaults, checkAssetForDefaults };
};
